<div style="display: flex; justify-content: flex-end; margin-bottom: 20px;">


  <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
    <i class="fa fa-times" style="color: #fff"></i>
  </button>
</div>
<div style="margin-top: -49px;margin-bottom: 10px;width: 80%;" class="content-top-row">
  <mat-form-field *ngIf="!isTechnician" style="margin-left: 0px;width: 50%;"
    class="top-row-first-filed-item top-row-first-filed-item-order-processing">
    <mat-label>Select Technician</mat-label>
    <mat-select [(value)]="selectedTechnicianId" (selectionChange)="onChangeTechnician($event)">
      <mat-select-filter [placeholder]="'Search'" [displayMember]="'fullName'" [array]="technicianList"
        (filteredReturn)="filtTechList = $event"></mat-select-filter>
      <mat-option *ngFor="let user of filtTechList" [value]="user.AssignTechnician">
        {{ user.fullName }}
      </mat-option>
    </mat-select>
  </mat-form-field>


</div>


<div style="border: 1px solid black;">
  <div class="logoBar">
    <img [src]="o3Logo1" style="width: 7rem;" alt="Not Available">
    <h1>Maintenance</h1>
    <img [src]="o3Logo2" alt="Not Available">
  </div>

  <div style="border-bottom: 1px solid black;">
    <table style="border-collapse: collapse; width: 100%;">
      <tr>
        <td style="border: none; padding: 10px">WO Id</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.woId}}</td>
        <td style="border: none; padding: 10px">WO Type</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.woType}}</td>
      </tr>
      <tr>
        <td style="border: none; padding: 10px">WO Details</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.woDetails}}</td>
      </tr>
      <tr>
        <td style="border: none; padding: 10px">Created At</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.createdAt}}</td>
        <td style="border: none; padding: 10px">Created By</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.createdBy}}</td>
      </tr>
    </table>
  </div>

  <div style="border-bottom: 1px solid black;height:50px">
  </div>

  <div style="border-bottom: 1px solid black;">
    <table style="border-collapse: collapse; width: 100%;">
      <tr>
        <td style="border: none; padding: 10px">Line</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.line}}</td>
        <td style="border: none; padding: 10px">Machine</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.machine}}</td>
      </tr>
      <tr>
        <td style="border: none; padding: 10px">Failure Mode</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.failureMode}}</td>
        <td style="border: none; padding: 10px">Spare Parts</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.sparePart}}</td>
      </tr>
      <tr>
        <td style="border: none; padding: 10px">Assmenbly</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.assembly}}</td>
        <td style="border: none; padding: 10px">Sub Assembly</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.subAssembly}}</td>
      </tr>
      <tr>
        <td style="border: none; padding: 10px">Components</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.component}}</td>
      </tr>
    </table>
  </div>

  <div style="border-bottom: 1px solid black;height:50px">
  </div>

  <div style="border-bottom: 1px solid black;">
    <table style="border-collapse: collapse; width: 100%;">
      <tr>
        <td style="border: none; padding: 10px">Assign Technician Time</td>
        <td style="border: none; padding: 10px">{{qrcodedetaildataArray.assignedTechnicianTime}}</td>
        <td style="border: none; padding: 10px">Assigned Technician</td>
        <td style="border: none; padding: 10px">{{ assignedTechnician }}</td>
      </tr>
    </table>
  </div>

  <div class="qrandTechnician">

    <div class="column1">
      <h3 [style.color]="qrcodedetaildataArray.priorityColor" [style.margin-top]="'10px'" [style.font-size]="'41px'">
        {{qrcodedetaildataArray.priority}}
      </h3>
      <div id="divToCapture" class="center-content">
        <qrcode #qrcodeContainer id="PrintVisible" [qrdata]="data?.data" [allowEmptyString]="true"
          [ariaLabel]="'QR Code image with the following content...'" [cssClass]="'center'" [colorDark]="'#000000ff'"
          [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [imageHeight]="75"
          [imageWidth]="75" [margin]="4" [scale]="1" [title]="'QR Code'" [width]="300"
          (qrCodeURL)="onChangeURL($event)">
        </qrcode>
        <div class="center-text">
          <p style="margin-top: -10px;margin-bottom: 0px; font-weight: 500; font-size: 21px;">
            {{qrcodedetaildataArray?.woId}}</p>
        </div>
      </div>
    </div>

    <div class="column2 center-content">
      <img *ngIf="technicianImage" [src]="blobUrl+technicianImage" alt="Not Available" class="image"
        style="height: 150px;width: 150px;">
      <img *ngIf="!technicianImage" src="assets/images/no-image.png" alt="Not Available" class="image"
        style="height: 150px;width: 150px;">
      <img [src]="toolsLogo" alt="Not Available" class="image" style="height: 150px;width: 150px;">
    </div>
  </div>


</div>

<div class="container" id="Printheaden2">
  <div class="left-button">
    <a mat-raised-button color="primary" (click)="PrintQRCode()">
      <span style="color:#fff">Print</span>
    </a>
  </div>
  <div class="btn-center">
    <button mat-raised-button color="primary" (click)="captureDiv()"> <span style="color:#fff">Download QR
        Code</span></button>
  </div>
  <div class="right-button">
    <a mat-raised-button color="primary" (click)="openDialog()">
      <span style="color:#fff">Detail</span>
    </a>
  </div>
</div>
<div id="Printheaden2">
  <a mat-raised-button color="primary" (click)="QrCode()" style="margin-left: 25%; margin-right: 25%; width: 50%;">
    <span style="color:#fff;width: fit-content;">Print Detail</span>
    <span>
      <i class="fa fa-print" aria-hidden="true" style="color: white;margin-left: 10px;"></i>
    </span>
  </a>
</div>
<div id="reportContainer"></div>